import { Player } from "@lottiefiles/react-lottie-player";
import { useEffect, useState } from "react";

const SlashAnimation = ({ onComplete, crit }) => {
  // Генерация случайных значений для позиции, поворота и масштаба
  const [rotate, setRotate] = useState(Math.floor(Math.random() * 90) - 45); // Случайный угол от -45 до 45 градусов
  const [translateX, setTranslateX] = useState(
    Math.floor(Math.random() * 40) - 20
  ); // Случайное смещение по X от -20px до 20px
  const [translateY, setTranslateY] = useState(
    Math.floor(Math.random() * 40) - 20
  ); // Случайное смещение по Y от -20px до 20px
  const [scale, setScale] = useState(Math.random() * 0.4 + 0.8); // Случайный масштаб от 0.8 до 1.2

  return (
    <div
      style={{
        position: "absolute",
        bottom: 30,
        transform: `translate(${translateX}px, ${translateY}px) rotate(${rotate}deg) scale(${scale})`, // Применяем трансформации
      }}
    >
      <Player
        autoplay
        loop={false}
        src={crit ? "slash-02.json" : "slash-01.json"}
        style={{ width: "50%" }}
        onEvent={(event) => {
          if (event === "complete") {
            onComplete(); // Вызываем колбэк после завершения анимации
          }
        }}
      />
    </div>
  );
};

export default SlashAnimation;
